import styled from 'styled-components';

export const StyledGuardianPeselField = styled.div`
   width: 278px;
`;
StyledGuardianPeselField.displayName = 'StyledGuardianPeselField';
